import { render } from "./ServerManager.vue?vue&type=template&id=2911b7ea&scoped=true"
import script from "./ServerManager.vue?vue&type=script&lang=js"
export * from "./ServerManager.vue?vue&type=script&lang=js"

import "./ServerManager.vue?vue&type=style&index=0&id=2911b7ea&scoped=true&lang=css"
import "./ServerManager.vue?vue&type=style&index=1&id=2911b7ea&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2911b7ea"]])

export default __exports__